define([
    'language/resource',
    'authui/iamUtils',
    'authui/widgets/step/step-simple',
    'base/js/fphone/controllers/fPhoneController',
    'base/utils/iamHttpService',
    'base/utils/utility'
], function (i18n, iamUtils, Step, FPhoneController,iamHttpService,util) {
    'use strict';

    var viewModel = [{
        title: i18n('fpwd.confirmAccount'),
        imgClz: 'step_img step1_img',
        imgClzHL: 'step_img step1_img_hl'
    }, {
        title: i18n('fphone.changePhoneNum'),
        imgClz: 'step_img step2_img',
        imgClzHL: 'step_img step2_img_hl'
    }, {
        title: i18n('fpwd.resetSuccess'),
        imgClz: 'step_img step3_img',
        imgClzHL: 'step_img step3_img_hl'
    }];
    var step = new Step('step', viewModel);
    step.goToStep(1);

    var ctrl = function ($scope, securityPolicy, $compile) {
        try{
            var userType = getQueryString('UserType');
            iamUtils.initialCloudBI('/authui/public/custom/findPhone.html?UserType='+ userType +'#/fphone',{C1:'IAM-Login-'+userType+'-fphone'});
        }catch(e){
            console.dir(e)
        }

        FPhoneController.call(this, $scope, $compile, i18n, iamUtils, step, securityPolicy);
        $scope.model.findPhoneValidator = iamUtils.validator.phoneAddIntl();
        $.extend(true, $scope.model, {
            onPhoneChange: function(event, value){
                $('#phoneError').empty();
                limitLength($scope.model.newPhoneNumId, value, 11);
            },
            disable: false
        });
    };

    function getQueryString(param) {
        var reg = '(^|&)' + param + '=([^&]*)(&|$)';
        var r = window.location.href.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    $.extend(ctrl.prototype, FPhoneController.prototype);

    ctrl.prototype.validatePhoneLength = function (value) {
        var pattern = /^\d*$/;
        return pattern.test(value);
    }
        
    ctrl.prototype.isKeyExisted = function ($scope, iamHttpService, type, countryCode, value, errorTxt, txtFielId, errorInfoid) {
        var userType = getQueryString('UserType');
        $scope.dft = $.Deferred();
	           iamHttpService.post({
	               url: '/authui/fphone/exists',
	               params: {
	                   domainName: userType === 'p' ? undefined : encodeURIComponent($('#' + $scope.model.enterpriseId).widget().getValue()),
	                   countryCode: countryCode,
	                   mobile: value,
	                   email: $('#' + $scope.model.registerEmailId).widget().getValue()
	               }
	           }).then(function (data) {
            //             roll back multiple account user share one phone number
            //	        	   if(userType === "p") {
            //	        		   if(data.count >= 6) {
            //	        			   addErrorInfo(i18n("fphone.exceedMaxAccounts"), txtFielId, errorInfoid);
            //		                    $scope.dft.reject();
            //	        		   }else {
            //	        			   showOkImg(txtFielId, errorInfoid);
            //		                   $scope.dft.resolve();
            //	        		   }
            //	        	   }else {
	        		   if(data.count) {
	        			   addErrorInfo(i18n('fphone.phoneRepeat'), txtFielId, errorInfoid, '');
		                   $scope.dft.reject();
	        		   } else {
	        			   showOkImg(txtFielId, errorInfoid);
		                   $scope.dft.resolve();
	        		   }
            //	        	   }
	        	   
	           }, function (data) {
	               addErrorInfo(i18n('systemException'), txtFielId, errorInfoid, '');
	               $scope.dft.resolve();
	           });
    }
        
    function limitLength(fieldId, value, length)
    {
        if (value.length > length)
        {
            $('#' +fieldId).val(value.substring(0, length));
        }
    }
        
    function addErrorInfo(errorTxt, txtFielId, errorInfoid,newLine)
    {
        util.removeErrorInfo(errorInfoid);
        var imgSrc = require('custom/images/verifycode_valid.png');
        var errorDomFragment = newLine + '<img src="' + imgSrc + '"><span>' + errorTxt + '</span>';
        $(errorInfoid).html(errorDomFragment)
            //显示错误信息时换行显示
            .css('display', 'block');
        var tempNewPhoneNum = $('#' + txtFielId);
        if(tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.addClass('tiny-input-text valid_error_input');
        }
        else{
            tempNewPhoneNum.find('input').addClass('tiny-input-text valid_error_input');
        }
    }

    function showOkImg(txtFielId, infoid)
    {
        util.removeErrorInfo(infoid);
        var tempNewPhoneNum = $('#' + txtFielId);
        if(tempNewPhoneNum[0].tagName === 'INPUT') {
            tempNewPhoneNum.removeClass('valid_error_input');
        }
        else{
            tempNewPhoneNum.find('input').removeClass('valid_error_input');
        }
        var imgSrc = require('custom/images/verifycode_success.png');
        var imgDom = '<img src="' + imgSrc + '"/>';
        $(infoid).html(imgDom)
            //显示对号时, 不换行
            .css('display', 'inline-block');        
    }
        
    ctrl = ['$scope', 'securityPolicy', '$compile', ctrl];

    var _IAMLocation = window._IAMLocation = window._IAMLocation||'';
    _IAMLocation='&step=1';
    try {
        sendToGA();
    }
    catch (e) {

    }

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.fphone.ctrl', ctrl);
    return ctrl;
}
    
);


// WEBPACK FOOTER //
// ./public/hws/js/fphone/controllers/fPhoneController.js